// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2Fz1v","actions":"GroupTable_actions__2fnEk","deleteModalFooter":"GroupTable_deleteModalFooter__16kSw"};